<template>
  <el-container id="previous_data">
      <el-main>
          <el-row class="page-title">
            <h1>過去データ</h1>
          </el-row>
          <div class="sp-display" v-if="device === 'sp'">
            <div class="sp-form">
              <div class="form-title">検索期間</div>
              <div class="form">
                  <div>
                    開始日
                    <el-date-picker v-model="startDate" class="date-form" type="date" placeholder="yyyy年mm月dd日" format="yyyy年MM月dd日" value-format="yyyyMMdd" :editable="isEditable" :pickerOptions="spPickerOptions"/>
                  </div>
                  <div>
                    終了日
                    <el-date-picker v-model="endDate" class="date-form" type="date" placeholder="yyyy年mm月dd日" format="yyyy年MM月dd日" value-format="yyyyMMdd" :editable="isEditable" :pickerOptions="spPickerOptions"/>
                  </div>
              </div>
            </div>  
            <PreviousCsvButton :streamData="streamData.dataset" :activeButton="isActiveDownloadButton" />
          </div>
          <div class="pc-display">
            <el-row type="flex" justify="center">
              <el-form class="from-to-form" :inline="true" :model="model" :rules="rules" ref="dateForm" @submit.native.prevent="getPreviousData">
                表示期間：
                <el-form-item prop="dateFrom">
                  <el-date-picker v-model="startDate" class="date-form" type="date" placeholder="yyyy年mm月dd日" format="yyyy年MM月dd日" value-format="yyyyMMdd" :editable="isEditable" :pickerOptions="spPickerOptions"/>
                </el-form-item>
                ～
                <el-form-item prop="dateTo">
                  <el-date-picker v-model="endDate" class="date-form" type="date" placeholder="yyyy年mm月dd日" format="yyyy年MM月dd日" value-format="yyyyMMdd" :editable="isEditable" :pickerOptions="spPickerOptions"/>
                </el-form-item>
                <el-button class="search-button" type="primary" native-type="submit" :loading="this.isLoading">検索</el-button>
                <PreviousCsvButton class="previous-csv-button" :streamData="streamData.dataset"/>
              </el-form>
            </el-row>


            <el-row>
              <el-tabs type="card" @tab-click="tabClickAction" v-model="activeTabName">
                <el-tab-pane v-for="(camera, index) in streamData.dataset" :key="camera.camera_name" :label="camera.camera_name">
                  <!--el-tabs全体をv-ifにより非活性にするとrefs周りのイベントでエラー発生するためel-collapseのみv-ifに非活性判定追加-->
                  <el-collapse v-model="activeNames" v-if="activeTabName == index && device === 'pc'">
                    <el-collapse-item title="時間帯別人数" name="1">
                      <PreviousTable :reportData="camera.data_list" :propertys="streamData.property" @update="updateGraph" v-if="activeNames.includes('1')" />
                    </el-collapse-item>
                    <el-collapse-item title="時間帯別最大人数グラフ  (※日付をクリックするとグラフが表示します。)" name="2" :disabled="isShowGraph">
                      <el-container class="active-date">{{activeGraphDate}}</el-container>
                      <PreviousGraphData :selectCameraData="maxDailyData" :allCameraData="camera" :threshold="camera.threshold" v-if="activeNames.includes('2')" />
                    </el-collapse-item>
                  </el-collapse>
                </el-tab-pane>
              </el-tabs>
            </el-row>
          </div>
      </el-main>
  </el-container>
</template>

<script>
import PreviousGraphData from '@/components/previous_data/PreviousGraphData.vue';
import PreviousTable from '@/components/previous_data/PreviousTable.vue';
import PreviousCsvButton from '@/components/previous_data/PreviousCsvButton.vue';
import mixin from '@/mixin/mixin.js';

export default {
    name: 'previous_data',
    mixins: [mixin],
    data() {

      var validateDateFromBeyondDateTo = (rule, value, callback) => {
        if (value > this.model.dateTo){
          callback(new Error('開始日付が終了日付を超えています'))
        } else {
          callback();
        }
      };

      return {
        model:{
          dateFrom: this.$store.state.previousData.terms.startDate,
          dateTo: this.$store.state.previousData.terms.endDate
        },
        rules:{
          dateFrom: [
              {validator: validateDateFromBeyondDateTo, trigger: "blur"},
              {required: true, message: "日付を入力してください",  trigger: "blur"},
          ],
          dateTo: [
              {required: true, message: "日付を入力してください",  trigger: "blur"},
          ],
        },
        
        dates: [
            this.$store.state.previousData.terms.startDate,
            this.$store.state.previousData.terms.endDate
          ],
        graph: true,
        activeNames: ["1"],
        isLoading: false,
        dailyData: {},
        stream: {},
        isEditable: false,
        tab: '',
        spPickerOptions: {
          disabledDate(time) {
            let dt = new Date()
            let yesterday = dt.setDate(dt.getDate() - 1)
            let threeMonthAgo = dt.setDate(dt.getDate() - 99)
            return time.getTime() >= yesterday || time.getTime() < threeMonthAgo
          }
        },
        pickerOptions: {
          disabledDate(time) {
            let dt = new Date()
            let yesterday = dt.setDate(dt.getDate() - 1)
            let threeMonthAgo = dt.setDate(dt.getDate() - 99)
            return time.getTime() >= yesterday || time.getTime() < threeMonthAgo
          },
          shortcuts: [{
            text: '直近一カ月間',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setDate(end.getDate() - 1)
              start.setMonth(start.getMonth() - 1);
              picker.$emit('pick', [start, end])
            }
          },{
            text: '直近一週間',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setDate(end.getDate() - 1);
              start.setDate(start.getDate() - 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '昨日',
            onClick(picker) {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              picker.$emit('pick', [yesterday, yesterday])
            }
          }]
        }
      }
    },

    components: {
      PreviousGraphData,
      PreviousTable,
      PreviousCsvButton
    },

    methods: {
      getPreviousData: async function() {
        let valid = await this.$refs['dateForm'].validate();
        if (!valid) {
          return;
        }
        
        this.activeNames = ["1"]
        this.dates = this.dates.filter(v => v)
        this.isLoading = true
        this.$store.dispatch('getPreviousData')
        .then(() => {
          this.graph = true
        })
        .catch(e => {
          this.$message.error(e.message)
        })
        .finally(() => {
          this.isLoading = false
        })
      },
      updateGraph(value) {
        this.graph = false
        this.dailyData = value
        this.activeNames.push("2")
      },
      tabClickAction() {
        this.dailyData = {}
        this.activeNames = this.activeNames.filter(n => n !== "2")
        this.graph = true
      },
    },
    computed: {
      startDate: {
          get() {
            return this.$store.state.previousData.terms.startDate
          },
          set(val) {
            this.$set(this.$store.state.previousData.terms, 'startDate', val)
            this.model.dateFrom = val
          }
      },
      endDate: {
          get() {
            return this.$store.state.previousData.terms.endDate
          },
          set(val) {
            this.$set(this.$store.state.previousData.terms, 'endDate', val)
            this.model.dateTo = val
          },
      },
      activeTabName: {
        get() {
          return this.tab
        },
        set(val) {
          this.tab = val
        }
      },
      // sp表示時利用
      isActiveDownloadButton() {
        let correctDates = false
        if (this.startDate && this.endDate) {
            if (this.startDate <= this.endDate) {
                correctDates = true
                
            } else {
                this.$message.error("開始日より後の日付を終了日に設定してください")
            }
        }
        return correctDates
      },
      streamData() {
          return this.$store.state.previousData.dataset
      },
      isShowGraph() {
          return this.graph
      },
      maxDailyData() {
          return this.dailyData
      },
      activeGraphDate() {
        return this.dailyData['date']
      }
    }
};
</script>

<style scoped>
  .el-row.page-title {
      padding: 0px;
  }
  
  .el-row.page-title >>> h1{
    margin-top: 0px;
  }
  
  .el-main {
    padding-left: 0px;
  }
  
  .el-row {
    padding: 20px;
  }
  
  .el-form .el-form-item{
    margin: 0;
  }
  
  .date-form, .search-button, .previous-csv-button{
    margin: 10px 2px;
  }
  
  h1 {
    font-size: 20px; 
  }
  
  .sp-display{
    display: none;
  }
  
  .active-date{
    padding: 20px;
    font-size: 15px;
  }
  
  @media screen and (max-width: 980px) {
    #previous_data >>> .pc-display{
      display: none;
    }
    
    .sp-display{
      display: block;
    }
    
    .el-main{
      padding-top: 7px;
      padding-left: 0px;
    }
    
    .el-row.page-title {
      padding-top: 20px;
    }
    
    .form{
      text-align: center;
      padding: 15px;
    }
    
    .date-form{
      padding-bottom: 10px;
    }
  }
</style>
